<template>
<div class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 ">
  <loading v-if="loadingState" />
  <div class="container  mb-5">


    <div class="row justify-content-center mb-3 ">

      <div class="col-md-12 mt-4">
        <h2 class=" " type="text"> Guida all'utilizzo e FAQ </h2>
      </div>

    </div>


    <div class="row justify-content-center vaillantCont pb-5 pt-3" >
      <div class="col-md-12 mt-4">
        <a v-if="brand == 'HAPPYBONUS'" class="black underline h5" href="https://storage.googleapis.com/happybonus/Guida_HappyBonus_Novembre_2021.pdf" target="_blank"><b> Guida all’utilizzo della nuova web app HappyBonus ed. Novembre ’21 </b></a>
        <a v-if="brand == 'CHEBONUS'" class="black underline h5" href="https://storage.googleapis.com/chebonus/Guida_CheBonus_Novembre_2021.pdf" target="_blank"><b> Guida all’utilizzo della nuova web app CheBonus ed. Novembre ’21 </b></a>
      </div>
    </div>


  </div>

</div>
</template>


<script>
import axios from 'axios'
export default {
  name: 'faq',
  components: {},
  data() {

    return {
      loadingState: false,
      brand: process.env.BRAND,
    }
  },
  methods: {

  },
  mounted: function(){
    this.$scrollTo('#app', 700, {
      offset: -775
    })
  }

}
</script>

<style lang="css" scoped>

.vaillantCont {
  height: 100%;
}

.wa_icon{
  max-width: 40px;
  margin-top: -11px;
}

</style>



// WEBPACK FOOTER //
// src/components/faq/index.vue